import { env } from '@/utils'

import { QR_TYPE, TQrContent } from '../generatorTypes'
import { getWifiTextToEncode } from '../qrTypes/Wifi/utils/getWifiTextToEncode'
import { TWifiContent } from '../qrTypes/Wifi/WifiContentState'

export const buildQrLandingUrl = (qrUri: string) => `${env.MOBI_URL}/${qrUri}`

export const getQrDataToEncode = ({
	qrUri,
	qrContent,
}: {
	qrUri: string
	qrContent: TQrContent
}) => {
	const isWifiType = qrContent.type === QR_TYPE.Wifi
	return isWifiType
		? getWifiTextToEncode(qrContent as TWifiContent)
		: buildQrLandingUrl(qrUri)
}
